const messages = {
  title: "Lucrări de mentenanță!",
  description:
    'În prezent se efectuează lucrările necesare de mentenanță pe servere.<br/><br/>Prin urmare, nu aveți momentan acces la <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>Vă rugăm să aveți răbdare și vă mulțumim pentru înțelegere.<br/><br/> Echipa dumneavoastră Bridgestone',
}
export default {
  messages
}
